import { useTranslation } from 'react-i18next'
import { Checkbox } from '@/components/shadcn/checkbox'
import { Label } from '@/components/shadcn/label'

// TimeSpan-Strings wie im alten Portal (Backend erwartet .NET-TimeSpan-Notation).
const ONE_WEEK = '7.00:00:00'
const ONE_DAY = '1.00:00:00'
const ONE_HOUR = '01:00:00'

interface Props {
  hasTime: boolean
  reminders: string[]
  onChange: (reminders: string[]) => void
}

/**
 * Reminder notifications as checkboxes (1 week / 1 day / 1 hour before).
 * The hour option only exists for appointments with a time.
 */
export function ReminderNotificationsPicker({ hasTime, reminders, onChange }: Props) {
  const { t } = useTranslation('service-modules-calendar')

  const toggle = (span: string, checked: boolean) => {
    const without = reminders.filter((r) => r !== span)
    onChange(checked ? [...without, span] : without)
  }

  const row = (span: string, label: string) => (
    <div className="flex items-center gap-2">
      <Checkbox
        id={`reminder-${span}`}
        checked={reminders.includes(span)}
        onCheckedChange={(v) => toggle(span, v === true)}
      />
      <Label htmlFor={`reminder-${span}`} className="font-normal">
        {label}
      </Label>
    </div>
  )

  return (
    <div className="flex flex-col gap-2">
      {row(ONE_WEEK, t('event.reminders.oneWeek'))}
      {row(ONE_DAY, t('event.reminders.oneDay'))}
      {hasTime && row(ONE_HOUR, t('event.reminders.oneHour'))}
    </div>
  )
}
